import { RecognitionBadge } from "@/components/recognition-badge/RecognitionBadge.tsx";
import { ApiRecognition } from "@/types/recognitions/recognition.types.ts";
import { Box, Button, Modal, ModalProps, Stack, Title, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

export interface RecognitionGiftSentModalProps extends ModalProps {
  recognition: ApiRecognition;
  recipientCount?: number;
  recipientName?: string;
}

export function RecognitionGiftSentModal({
  recognition,
  recipientCount,
  recipientName,
  ...props
}: RecognitionGiftSentModalProps) {
  const { t } = useTranslation();
  const { close } = useModals();
  const { id } = props;

  const caption = recipientName
    ? t("recognition:gift_gifted_to", { name: recipientName })
    : t("recognition:gift_recipients_gifted", { count: recipientCount ?? 0 });

  return (
    <Modal
      {...props}
      title={t("recognition:gift_success")}
      withCloser
      actions={
        <Button size={"lg"} className={"w-full"} onClick={() => close(id)}>
          {t("common:ok")}
        </Button>
      }
    >
      <Stack gap={"sm"} items={"center"}>
        <RecognitionBadge template={recognition} size={"sm"} />
        <Box className={"text-center **:justify-center"}>
          <Title size={"lg"} paddingBottom={true} header={recognition.title} caption={caption} />
        </Box>
      </Stack>
    </Modal>
  );
}
